export default __webpack_public_path__ + "assets/icons/pdf-icon.0f476c63.svg";